import _extends from "@babel/runtime/helpers/esm/extends";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import InfoButtonComponent from './InfoButtonComponent';
import { borderShadowKeys, borderShadowMixin } from '../../mixins/border';
import { buttonCursorMixin } from '../../mixins/button';
import { omitProps } from '../../helpers/elements';
import { fullHeightKeys, fullHeightMixin, fullWidthKeys, fullWidthMixin } from '../../mixins/layout';
import { buttonResetStyle } from '../../tokens/button';
import { appearanceNoneStyle } from '../../tokens/appearance';
import { baseHighlightStyle } from '../../tokens/highlight';
var InfoButton = styled(omitProps(function (props, ref) {
  return /*#__PURE__*/React.createElement(InfoButtonComponent, _extends({
    ref: ref
  }, props));
}, [].concat(borderShadowKeys, fullWidthKeys, fullHeightKeys)))(_templateObject(), borderShadowMixin, buttonCursorMixin, buttonResetStyle, appearanceNoneStyle, fullWidthMixin, fullHeightMixin, baseHighlightStyle);
export default InfoButton;